{
  "pages": [
    {
      "name": "Pump Standalone",
      "elements": [
        {
          "type": "panel",
          "name": "Pump Standalone",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            }
          ],
          "title": "Pump standalone info",
          "isRequired": true
        },
        {
          "type": "panel",
          "name": "panel7",
          "elements": [
            {
              "type": "dropdown",
              "name": "P_type",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "Magna3",
                  "text": "MAGNA3"
                },
                {
                  "value": "TPE",
                  "text": "TPE"
                },
                {
                  "value": "TPE2",
                  "text": "TPE2"
                },
                {
                  "value": "TPE3",
                  "text": "TPE3"
                },
                {
                  "value": "Alpha",
                  "text": "ALPHA"
                },
                {
                  "value": "UPS",
                  "text": "UPS"
                },
                {
                  "value": "Pump",
                  "text": "Other"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "P_location",
              "title": "Location",
              "isRequired": true,
              "choices": [
                {
                  "value": "Forward",
                  "text": "Forward"
                },
                {
                  "value": "Return",
                  "text": "Return"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "P_connected",
              "visibleIf": "{P_type} = \"Magna3\" or {P_type} = \"TPE\" or {P_type} = \"TPE2\" or {P_type} = \"TPE3\"",
              "title": "Enable pump connectivity?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "P_address",
              "visibleIf": "{P_connected} = true",
              "isRequired": false,
              "title": "Bus address",
              "inputType": "number"
            },
            {
              "type": "boolean",
              "name": "PumpTemperatureSensor",
              "visibleIf": "{P_connected} = true",
              "title": "Extra temperature sensor connected to pump required?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Pump"
        }
      ]
    }
  ]
}